import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PeymentService } from '@api/peyment.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'environments/environment';
import jalaliMoment = require('jalali-moment');

@Component({
  selector: 'app-request-rial-detail',
  templateUrl: './request-rial-detail.component.html',
  styleUrls: ['./request-rial-detail.component.scss']
})
export class RequestRialDetailComponent implements OnInit {
  baseURL = environment.baseUrl;
  depositDetailId;
  DepositRequest;
  public destroy$ = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute , private paymentService: PeymentService , public router: Router) { }

  ngOnInit(): void {
    this.depositDetailId = this.activatedRoute.snapshot.params.id
    this.paymentService.DepositRequestById(this.depositDetailId).pipe(takeUntil(this.destroy$))
    .subscribe((res: any) => {
      this.DepositRequest = res;
      this.DepositRequest.forEach((element): any => {
        const miladiDate = new Date(); 
        element.requestDate = jalaliMoment(miladiDate).format('jYYYY/jMM/jDD hh:mm');
      });
    });
  }

  postDepositRequest(approveStatus) {
    const data = {id: +this.depositDetailId, approveStatus : approveStatus}
    this.paymentService.postDepositRequest(data).subscribe((res: any) =>{
      if(res.status === 200 || res.status === 201 ){
        this.router.navigateByUrl('/deposit-request', {skipLocationChange: false});
      }
    }
  
    );
  }
  convertToCommas(x) {
    const value = Math.trunc(x);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
